export const POSTHOG_DOMAIN = 'ttc-ph';
